import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'day8-ui';
import { FaTag } from '@react-icons/all-files/fa6/FaTag';
import { getSelectedFilters, onFilterSelect } from '../../../../helpers/filter';
import { FILTERS } from '../../../../constants';
import { useDispatch } from 'react-redux';

const DealsFilter = props => {
  const dispatch = useDispatch();
  const isActive = !!getSelectedFilters(props.location)[FILTERS.DEALS];
  const toggle = () => onFilterSelect(
    props.location,
    dispatch,
    props.filterAction,
    FILTERS.DEALS,
    isActive ? null : 'active'
  );
  return props.mobile ? (
    <div className={props.className}>
      <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>Deals</h3>
      <div className='dui-flex dui-flex-wrap dui-gap-4 dui-mt-4'>
        <Button
          buttonType={isActive ? 'FILTER_ACTIVE' : 'FILTER'}
          leftIcon={<FaTag />}
          onClick={toggle}
        >
          Ongoing deals
        </Button>
      </div>
    </div>
  ) : (
    <Button buttonType="LINK" leftIcon={<FaTag />} onClick={toggle}>
      {isActive ? 'Deals: on' : 'Deals'}
    </Button>
  );
};
DealsFilter.propTypes = {
  mobile: PropTypes.bool,
  filterModalToggle: PropTypes.bool,
  className: PropTypes.string,
  location: PropTypes.object,
  filterAction: PropTypes.func.isRequired
};
export default DealsFilter;
